import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { ActiveEventDot, ActiveYearDot } from './Icons/DotsIcons'

const TimelineControls = ({ events, eventAction, current }) => {
  const timelineControls = useMemo(() => events, [events])

  return (
    <ol className="timeline-controls">
      {timelineControls.map((item, index) => {
        return (
          <li
            className="timeline-control-item"
            key={index}
            onClick={item.id ? () => eventAction(item.id, current) : () => {}}
          >
            <div className={item?.primary ? 'year-group' : 'year-event'}>
              {item.id === current ? (
                item?.primary ? (
                  <ActiveYearDot />
                ) : (
                  <ActiveEventDot />
                )
              ) : (
                <div className={`dot ${!item.id ? 'no-events' : ''}`}></div>
              )}

              {item?.primary && (
                <span className={`${!item.id ? 'text-no-events' : ''}`}>{item.year}</span>
              )}
            </div>
          </li>
        )
      })}
    </ol>
  )
}

TimelineControls.propTypes = {
  events: PropTypes.array,
  eventAction: PropTypes.func,
  current: PropTypes.number,
}

export default TimelineControls
